export const enum LocalStorageKeys {
  FEATURE_TYPES = "featuretypes",
  LAYERS = "layers",
  CURRENCIES = "currencies",
  USER_DETAILS = "userDetails",
  TRANSACTION_CURRENCY = "transactionCurrency",
  AUTO_DETECTED_CURRENCY = "autoDetectedCurrency",
  BOUNDARIES = "boundaries",
  THEME = "theme",
  PENDING_PREMIUM_ORDER = "pendingPremiumOrder",
}
